function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "menu");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-4.3%",
  y: "-26.7%",
  width: "108.5%",
  height: "153.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.104110054 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Flow-5",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "1.-Homepage-Mobile",
  transform: "translate(-327.000000, -111.000000)",
  stroke: "#43C979",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-14",
  filter: "url(#filter-1)",
  transform: "translate(0.000000, 94.000000)"
}, React.createElement("g", {
  id: "menu",
  transform: "translate(334.000000, 22.000000)"
}, React.createElement("path", {
  d: "M0,7.38461538 L22.1538462,7.38461538",
  id: "Shape"
}), React.createElement("path", {
  d: "M0,0 L22.1538462,0",
  id: "Shape"
}), React.createElement("path", {
  d: "M0,14.7692308 L22.1538462,14.7692308",
  id: "Shape"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "36px",
    height: "29px",
    viewBox: "0 0 36 29",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/hamburger.e1596207.svg";
export { SvgComponent as ReactComponent };